import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import BoxInside from '../../../core/BoxInside';
import CalendarFood from '../../../core/CalendarLunch/CalendarLaunch';
import EventsCalendarHeader from '../../../core/CalendarLunch/EventsCalendarHeader';
import { StyledMonthHeader } from '../../../core/Calendar/style';
// eslint-disable-next-line import/no-webpack-loader-syntax,import/no-unresolved
import '!!style-loader!css-loader!react-big-calendar/lib/css/react-big-calendar.css';
// eslint-disable-next-line import/no-webpack-loader-syntax,import/no-unresolved
import '!!style-loader!css-loader!./foodTickets.css';

import {
  WrapperFlex,
  WrapperFoodPayFlex,
  WrapperCoupons,
  WrapperCalendar,
  TitleFoodPay,
  StyledFoodPayAvalaible,
  StyledFoodPayConsumed,
  StyleEventTitle,
  StyleEventText
} from './style';

const Event = ({ event }) => (
  <StyleEventTitle>
    <StyleEventText>{event.title}</StyleEventText>
  </StyleEventTitle>
);

const FormattedMonthHeader = ({ label, date }) => {
  const newLabel = label.slice(0, -1);
  const isWeekend = !!(date.getDay() === 6 || date.getDay() === 0);

  return <StyledMonthHeader weekend={isWeekend}>{newLabel}</StyledMonthHeader>;
};

const components = {
  toolbar: EventsCalendarHeader,
  event: Event,
  month: {
    header: FormattedMonthHeader
  }
};

const FoodTickets = ({ data: { dailyUses, available, used } }) => (
  <Fragment>
    <BoxInside>
      <WrapperFlex>
        <WrapperCoupons>
          <TitleFoodPay>Tus vales de comida para este mes</TitleFoodPay>
          <WrapperFoodPayFlex>
            <StyledFoodPayAvalaible type="Disponibles" quantity={available} />
            <StyledFoodPayConsumed type="Consumidos" quantity={used} />
          </WrapperFoodPayFlex>
        </WrapperCoupons>
        <WrapperCalendar>
          <CalendarFood events={dailyUses} components={components} />
        </WrapperCalendar>
      </WrapperFlex>
    </BoxInside>
  </Fragment>
);

FormattedMonthHeader.propTypes = {
  label: PropTypes.string,
  date: PropTypes.instanceOf(Date)
};

FoodTickets.propTypes = {
  data: PropTypes.shape({
    dailyUses: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        start: PropTypes.instanceOf(Date),
        end: PropTypes.instanceOf(Date),
        id: PropTypes.number
      })
    ),
    available: PropTypes.number,
    fakeUsed: PropTypes.number
  })
};

export default FoodTickets;
